import Keycloak from "keycloak-js";

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
export const keycloak: Keycloak = new (Keycloak)({
    realm: import.meta.env.VITE_IRIS_REALM,
    url: import.meta.env.VITE_IRIS_URL,
    clientId: import.meta.env.VITE_IRIS_CLIENTID,
});

export default keycloak;

